import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type StepSectionProps = {
  title: ReactNode;
  subtitle?: string;
  children: ReactNode;
};

const StepSection = ({ title, subtitle, children }: StepSectionProps) => (
  <Stack spacing={2}>
    <Stack
      spacing={1}
      useFlexGap>
      {typeof title === "string" ? (
        <Typography sx={{ color: "#081B3A", fontWeight: 700, fontSize: { xs: 32, sm: 36 } }}>{title}</Typography>
      ) : (
        title
      )}

      {subtitle && (
        <Typography
          variant='body16rg'
          sx={{ color: "#35507E", lineHeight: 1.55, fontSize: 18, maxWidth: 560 }}>
          {subtitle}
        </Typography>
      )}
    </Stack>

    <Stack spacing={3}>{children}</Stack>
  </Stack>
);

export default StepSection;
